import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deviceListing: {
    loading: false,
    error: null,
    data: null,
  },
  addDevice: {
    loading: false,
    error: null,
    data: null,
  },
  getDeviceData: {
    loading: false,
    error: null,
    data: null,
  },
  getDeviceDetails: {
    loading: false,
    error: null,
    data: null,
  },
  deleteUserDevice: {
    loading: false,
    error: null,
    data: null,
  }
};

const authSlice = createSlice({
  name: "devices",
  initialState,
  reducers: {
    addDeviceStart: (state) => {
      state.addDevice.loading = true;
      state.addDevice.error = null;
      state.addDevice.data = null;
    },
    addDeviceSuccess: (state, action) => {
      state.addDevice.loading = false;
      state.addDevice.data = action.payload;
      state.addDevice.error = null;
    },
    addDeviceFailure: (state, action) => {
      state.addDevice.loading = false;
      state.addDevice.error = action.payload;
      state.addDevice.data = null;
    },
    addDeviceResetForm: (state, action) => {
      state.addDevice.loading = false;
      state.addDevice.error = null;
      state.addDevice.data = null;
    },
    deviceListingStart: (state) => {
      state.deviceListing.loading = true;
      state.deviceListing.error = null;
      state.deviceListing.data = null;
    },
    deviceListingSuccess: (state, action) => {
      state.deviceListing.loading = false;
      state.deviceListing.data = action.payload;
      state.deviceListing.error = null;
    },
    deviceListingFailure: (state, action) => {
      state.deviceListing.loading = false;
      state.deviceListing.error = action.payload;
      state.deviceListing.data = null;
    },
    deviceListingReset: (state, action) => {
      state.deviceListing.loading = false;
      state.deviceListing.error = null;
      state.deviceListing.data = null;
    },
    getDeviceDataStart: (state) => {
      state.getDeviceData.loading = true;
      state.getDeviceData.error = null;
      state.getDeviceData.data = null;
    },
    getDeviceDataSuccess: (state, action) => {
      state.getDeviceData.loading = false;
      state.getDeviceData.data = action.payload;
      state.getDeviceData.error = null;
    },
    getDeviceDataFailure: (state, action) => {
      state.getDeviceData.loading = false;
      state.getDeviceData.error = action.payload;
      state.getDeviceData.data = null;
    },
    getDeviceDetailsStart: (state) => {
      state.getDeviceDetails.loading = true;
      state.getDeviceDetails.error = null;
      state.getDeviceDetails.data = null;
    },
    getDeviceDetailsSuccess: (state, action) => {
      state.getDeviceDetails.loading = false;
      state.getDeviceDetails.data = action.payload;
      state.getDeviceDetails.error = null;
    },
    getDeviceDetailsFailure: (state, action) => {
      state.getDeviceDetails.loading = false;
      state.getDeviceDetails.error = action.payload;
      state.getDeviceDetails.data = null;
    },
    deleteUserDeviceStart: (state) => {
      state.deleteUserDevice.loading = true;
      state.deleteUserDevice.error = null;
      state.deleteUserDevice.data = null;
    },
    deleteUserDeviceSuccess: (state, action) => {
      state.deleteUserDevice.loading = false;
      state.deleteUserDevice.data = action.payload;
      state.deleteUserDevice.error = null;
    },
    deleteUserDeviceFailure: (state, action) => {
      state.deleteUserDevice.loading = false;
      state.deleteUserDevice.error = action.payload;
      state.deleteUserDevice.data = null;
    },
  },
});

export const {
  addDeviceFailure,
  addDeviceSuccess,
  addDeviceStart,
  deviceListingFailure,
  deviceListingStart,
  deviceListingSuccess,
  getDeviceDataStart,
  getDeviceDataFailure,
  deviceListingReset,
  getDeviceDataSuccess,
  getDeviceDetailsStart,
  getDeviceDetailsSuccess,
  getDeviceDetailsFailure,
  addDeviceResetForm,
  deleteUserDeviceStart,
  deleteUserDeviceSuccess,
  deleteUserDeviceFailure
} = authSlice.actions;

export default authSlice.reducer;
